import { BaseField } from '@epages/react-components'
import { Component } from 'react'
import PropTypes from 'prop-types'

/*
 * Gets the current form value defined by `name` from  the `context`
 */
export default class FormValue extends Component {
  static contextType = BaseField.contextType

  static propTypes = {
    ...BaseField.propTypes,
    children: PropTypes.func.isRequired,
  }

  render() {
    const formValueScope = this.context.instance
    const { name, children } = this.props

    return children(formValueScope.getValue(name), (newValue) => formValueScope.setValue(name, newValue))
  }
}
